import api from '@/utils/api'

export default {
    getStudentOffer(urlCode) {
        return api.get(`unistudents/offer-by-url-code/${urlCode}`)
    },
    redeemCoupon(urlCode, couponId) {
        return api.post(
            `unistudents/offer-by-url-code/${urlCode}/redeem-coupon/${couponId}`
        )
    }
}
